"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
        onCreate: function() {
          GState.bind(this, [
              "user"
            ]);
        },
        onNext: function() {
          this.emit("next", this.input.index, null);
        }
      },
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Onboarding/components/Introduction.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Image_template = require("../../../../components/Image/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Image_tag = marko_loadTag(Image_template),
    Locale_template = require("../../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    Bx_template = require("../../../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    AutoScroll_template = require("marko-perfect-scrollbar/index.marko"),
    AutoScroll_tag = marko_loadTag(AutoScroll_template),
    marko_attrs0 = {
        "class": "w-100 text-center p-lg-5 p-2"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("203c94"),
    marko_node0 = marko_createElement("br", null, "3", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node1 = marko_createElement("br", null, "4", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs1 = {
        "class": "font-mediun-5"
      },
    marko_node2 = marko_createElement("br", null, "8", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node3 = marko_createElement("br", null, "9", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs2 = {
        "class": "font-medium-3 px-lg-5"
      },
    marko_node4 = marko_createElement("br", null, "12", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node5 = marko_createElement("br", null, "13", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs3 = {
        "class": "navigation-buttons"
      },
    marko_attrs4 = {
        "class": "btn btn-primary btn-xl text-left d-inline-block w-50"
      };

function render(input, out, __component, component, state) {
  var data = input;

  AutoScroll_tag({
      class: "h-100 d-flex align-items-center",
      renderBody: function(out) {
        out.be("div", marko_attrs0, "1", component);

        Image_tag({
            alt: "Image",
            src: "/images/illustration/introduction.png",
            class: "img-fluid col-10"
          }, out, __component, "2");

        out.n(marko_node0, component);

        out.n(marko_node1, component);

        out.be("div", null, "5", component);

        out.be("h3", marko_attrs1, "6", component);

        Locale_tag({
            text: "Hello"
          }, out, __component, "7");

        out.t(", ");

        out.t(state.user.first_name, component);

        out.t("!");

        out.ee();

        out.n(marko_node2, component);

        out.n(marko_node3, component);

        out.be("p", marko_attrs2, "10", component);

        Locale_tag({
            renderBody: function(out) {
              out.t("We are very glad having you joining out great community of online facilitated institutonal system. You are just about few minutes to setup your brand new institution. Ready?");
            }
          }, out, __component, "11");

        out.ee();

        out.n(marko_node4, component);

        out.n(marko_node5, component);

        out.be("div", marko_attrs3, "14", component);

        out.be("button", marko_attrs4, "15", component, null, 0, {
            onclick: __component.d("click", "onNext", false)
          });

        Bx_tag({
            type: "right-arrow-alt",
            class: "font-large-1 float-right white-text"
          }, out, __component, "16");

        Locale_tag({
            text: "Let's get started"
          }, out, __component, "17");

        out.ee();

        out.ee();

        out.ee();

        out.ee();
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
